if (!customElements.get('collection-list')) {
  class CollectionList extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        scroller: '.collection-list__items',
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.scroller = this.querySelector(this.selectors.scroller);

      this.nextBtn = this.section.querySelector(this.selectors.nextEl);
      this.prevBtn = this.section.querySelector(this.selectors.prevEl);

      if (!this.scroller) return;

      this.init();
    }

    init() {
      this.bindArrows();

    }

    bindArrows() {
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.scrollByAmount(1);
        });
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.scrollByAmount(-1);
        });
      }
    }

    scrollByAmount(direction = 1) {
      const firstSlide = this.scroller.querySelector('.swiper-slide');
      if (!firstSlide) return;

      const gap = parseFloat(getComputedStyle(this.scroller).columnGap || 0);
      const width = firstSlide.offsetWidth + gap;

      this.scroller.scrollBy({
        left: width * direction,
        behavior: 'smooth',
      });
    }
  }

  customElements.define('collection-list', CollectionList);
}